/* eslint-disable no-unused-vars */
import { DragEvent, DragEventHandler, useRef, useState } from "react";

export type DraggableUpload<T = Element> = {
  dragging: boolean;
  onDragEnter: DragEventHandler<T>;
  onDragLeave: DragEventHandler<T>;
  onDragOver: DragEventHandler<T>;
  onDrop: DragEventHandler<T>;
};

function useDraggableUpload<T = HTMLDivElement>(onFileSelect: (file: FileList) => void): DraggableUpload<T> {
  const [dragging, setDragging] = useState<boolean>(false);
  const dragCounter = useRef<number>(0);

  const handleDragEnter = (e: DragEvent<T>) => {
    e.preventDefault();
    e.stopPropagation();
    dragCounter.current += 1;
    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      setDragging(true);
    }
  };

  const handleDragLeave = (e: DragEvent<T>) => {
    e.preventDefault();
    e.stopPropagation();
    dragCounter.current -= 1;
    if (dragCounter.current === 0) {
      setDragging(false);
    }
  };

  const handleDragOver = (e: DragEvent<T>) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e: DragEvent<T>) => {
    e.preventDefault();
    e.stopPropagation();

    dragCounter.current -= 1;
    setDragging(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const fileObj = e.dataTransfer.files;
      onFileSelect(fileObj);
      e.dataTransfer.clearData();
    }
  };

  return {
    dragging,
    onDragEnter: handleDragEnter,
    onDragLeave: handleDragLeave,
    onDragOver: handleDragOver,
    onDrop: handleDrop,
  };
}

export default useDraggableUpload;
